// Brand palette plus a custom hex escape hatch — shared by every editable section.
export const ACCENT_OPTIONS = ["gold", "blue", "green", "lime", "neutral", "custom"];

const PALETTE = {
    gold: "#E5A900",
    blue: "#4C7DFF",
    green: "#3FA36B",
    lime: "#7CB342",
    neutral: "#8E8E93",
};

export const accentHex = (accent, custom) =>
    (accent === "custom" ? (custom || PALETTE.gold) : (PALETTE[accent] || PALETTE.gold));

/** Card styling for any accent, in both the dark and light public themes. */
export const accentCard = (accent = "gold", custom = "") => {
    const hex = accentHex(accent, custom);
    return {
        className: "sci-card",
        style: {
            "--tint": `${hex}24`,
            "--edge": `${hex}6b`,
            "--edge-hover": `${hex}cc`,
            "--glow": `${hex}d9`,
            "--rule": `linear-gradient(90deg, ${hex}, ${hex}88 45%, transparent)`,
        },
        hex,
    };
};
